/* eslint-env browser */
import plyr from 'plyr';
import { fire } from 'domassist';
import yt from './youtube';

const plugins = {
  youtube: yt
};

const instances = [];
const Events = {
  Start: 'video:start',
  End: 'video:end'
};

function broadcast(player, event) {
  const container = player.getContainer();
  const embed = player.getEmbed();
  const type = event === Events.Start ? 'video start' : 'video end';

  let title = '';

  if (embed.getVideoData) {
    title = embed.getVideoData().title;
  }

  fire(container, event, {
    bubbles: true,
    detail: {
      type: [type, title].join(' ').trim()
    }
  });
}

function onPlay(instance) {
  if (!instance.played) {
    instance.played = true;
    broadcast(instance.player, Events.Start);
  }
}

function onEnd(instance) {
  if (!instance.ended) {
    instance.ended = true;
    broadcast(instance.player, Events.End);
  }
}

function patchEmbed(i) {
  const p = i.player;

  if (typeof p.getEmbed !== 'undefined' && !!p.getEmbed()) {
    i.embed = p.getEmbed();
    const type = p.getType();

    if (plugins[type]) {
      plugins[type](i);
    }
  } else {
    setTimeout(() => patchEmbed(i), 500);
  }
}

export default {
  setup(el) {
    const args = [];

    if (el) {
      args.push(el);
    }

    args.push({
      iconUrl: window.urls.plyrIcons
    });

    const players = plyr.setup.apply(plyr, args);

    if (players && players.length) {
      players.forEach(p => {
        const i = instances.length;
        instances.push({
          player: p,
          played: false,
          ended: false
        });

        patchEmbed(instances[i]);

        p.on('plyr:playing', () => onPlay(instances[i]));
        p.on('plyr:ended', e => onEnd(instances[i], e));
      });
    }

    return players.length === 1 ? players[0] : players;
  }
};

export { Events };
